import type { FC } from 'react';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { TPO_NO_PROMOS_MODAL } from '../../../config/testIds';
import useDeleteEventMutation from '../hooks/useDeleteEventMutation';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';

export interface NoPromosModalProps {
    open: boolean;
    onClose: () => void;
    eventId: string | null;
    onDeleteSuccess: () => void;
}

const NoPromosModal: FC<NoPromosModalProps> = ({ open, onClose, eventId, onDeleteSuccess }) => {
    const tpoGenConfig = useTpoGenConfig();
    const { mutate: deleteEvent, isPending } = useDeleteEventMutation({
        onSuccess: () => {
            onClose();
            onDeleteSuccess();
        },
    });

    const description = (
        <div className="bg-[#fafafa] rounded-lg p-2">
            <p className="text-sm text-[#18181b]">{tpoGenConfig.labels.modals.noPromotionsDescription}</p>
        </div>
    );

    return (
        <ConfirmationModal
            data-testid={TPO_NO_PROMOS_MODAL}
            open={open}
            title={tpoGenConfig.labels.modals.noPromotionsTitle}
            okText={tpoGenConfig.labels.modals.continueEditing}
            cancelText={tpoGenConfig.labels.modals.deleteEvent}
            loading={isPending}
            closable={false}
            maskClosable={false}
            onSubmitClick={onClose}
            onCancel={() => {
                if (eventId) deleteEvent(eventId);
            }}
            description={description}
            width={520}
        />
    );
};

NoPromosModal.displayName = 'NoPromosModal';
export default NoPromosModal;
